import script from "./ClientLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientLogin.vue?vue&type=script&setup=true&lang=js"

import "./ClientLogin.vue?vue&type=style&index=0&id=5e663e4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e663e4e"]])

export default __exports__